import { getChangePlanUrl, getFastspringSessionUrl } from '../utils/links';
import omitBy from 'lodash/omitBy';
import isNull  from 'lodash/isNull';

// filter null, undefined and empty string
const filterEmptyParams = (params) =>
  omitBy(
    params,
    (val) => val === undefined || isNull(val) || (typeof val === 'string' && val.length === 0),
  );

// params = {plan: 'standard'|'pro'|'standardannual'|'proannual', coupon?: string, origin?: string }: Promise<string>
export const getFastspringSessionId = (params) =>
  fetch(getFastspringSessionUrl(filterEmptyParams(params)))
    .then((res) => res.json())
    .then(({ session_id }) => session_id);

// params = {plan: 'standard'|'pro'|'standardannual'|'proannual', coupon?: string, origin?: string }: Promise<string>
export const prorateSubscription = (params) =>
  fetch(getChangePlanUrl(filterEmptyParams(params))).then((res) => res.json());
